const blockColors = {
    looks: {
        colourPrimary: '#1E1433',
        colourSecondary: '#4C4C4C',
        colourTertiary: '#9966FF',
        colorQuaternary: '#9966FF'
    },
    control: {
        colourPrimary: '#332205',
        colourSecondary: '#4C4C4C',
        colourTertiary: '#FFAB19',
        colorQuaternary: '#FFAB19'
    },
    sensing: {
        colourPrimary: '#12232A',
        colourSecondary: '#4C4C4C',
        colourTertiary: '#5CB1D6',
        colorQuaternary: '#5CB1D6'
    },
    operators: {
        colourPrimary: '#112611',
        colourSecondary: '#4C4C4C',
        colourTertiary: '#59C059',
        colorQuaternary: '#59C059'
    },
    variables: {
        colourPrimary: '#331C05',
        colourSecondary: '#4C4C4C',
        colourTertiary: '#FF8C1A',
        colorQuaternary: '#FF8C1A'
    },
    lists: {
        colourPrimary: '#331405',
        colourSecondary: '#4C4C4C',
        colourTertiary: '#FF661A',
        colorQuaternary: '#FF661A'
    },
    data: {
        colourPrimary: '#331C05',
        colourSecondary: '#4C4C4C',
        colourTertiary: '#FF8C1A',
        colorQuaternary: '#FF8C1A'
    },
    data_lists: {
        colourPrimary: '#331405',
        colourSecondary: '#4C4C4C',
        colourTertiary: '#FF661A',
        colorQuaternary: '#FF661A'
    },
    output: {
        colourPrimary: '#1E1433',
        colourSecondary: '#4C4C4C',
        colourTertiary: '#9966FF',
        colorQuaternary: '#9966FF'
    },
    decisions: {
        colourPrimary: '#332205',
        colourSecondary: '#4C4C4C',
        colourTertiary: '#FFAB19',
        colorQuaternary: '#FFAB19'
    },
    iteration: {
        colourPrimary: '#332205',
        colourSecondary: '#4C4C4C',
        colourTertiary: '#FFAB19',
        colorQuaternary: '#FFAB19'
    },
    input: {
        colourPrimary: '#12232A',
        colourSecondary: '#4C4C4C',
        colourTertiary: '#5CB1D6',
        colorQuaternary: '#5CB1D6'
    },
    values: {
        colourPrimary: '#112611',
        colourSecondary: '#4C4C4C',
        colourTertiary: '#59C059',
        colorQuaternary: '#59C059'
    },
    conversions: {
        colourPrimary: '#112611',
        colourSecondary: '#4C4C4C',
        colourTertiary: '#59C059',
        colorQuaternary: '#59C059'
    },
    text: 'rgba(255, 255, 255, .7)',
    textFieldText: '#E5E5E5',
    workspace: '#121212',
    toolboxSelected: '#4C4C4C',
    toolboxText: '#E5E5E5',
    toolbox: '#121212',
    flyout: '#121212',
    textField: '#4C4C4C',
    menuHover: 'rgba(255, 255, 255, 0.3)'
};

const extensions = {};

export {
    blockColors,
    extensions
};
